/**
 * @name tool-case
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTVoNCIgLz4KICA8cGF0aCBkPSJtMTQuNSA0LjA1OC41NzEtMS40MjlhMSAxIDAgMDExLjMtLjU1OGw1IDJhMSAxIDAgMDEuNTQ5LjUzNC44OC44OCAwIDAxLjAxLjc2NWwtMi4zMzIgNS44MyIgLz4KICA8cGF0aCBkPSJNMTUuNjM0IDExYTIgMiAwIDAwLS4xODYtLjM0bC0xLjE3LTEuNzU3IDEuMzEtMS42NTZhMiAyIDAgMDAtMi4xMDktMy4xNjVsLTIuMDMyLjU3LTEuMTctMS43NThhMiAyIDAgMDAtMy42NjQgMS4wMjhsLS4wODYgMi4xMS0yLjAzMi41NjhhMiAyIDAgMDAtLjE1NSAzLjhsMS42MTcuNiIgLz4KICA8cGF0aCBkPSJNNCAxMi4wMDZBMSAxIDAgMDE0Ljk5NCAxMUgxOWExIDEgMCAwMTEgMXY3YTIgMiAwIDAxLTIgMkg2YTIgMiAwIDAxLTItMnoiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/tool-case
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const ToolCase: string = `
<svg
  class="lucide lucide-tool-case"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M10 15h4" />
  <path d="m14.5 4.058.571-1.429a1 1 0 011.3-.558l5 2a1 1 0 01.549.534.88.88 0 01.01.765l-2.332 5.83" />
  <path d="M15.634 11a2 2 0 00-.186-.34l-1.17-1.757 1.31-1.656a2 2 0 00-2.109-3.165l-2.032.57-1.17-1.758a2 2 0 00-3.664 1.028l-.086 2.11-2.032.568a2 2 0 00-.155 3.8l1.617.6" />
  <path d="M4 12.006A1 1 0 014.994 11H19a1 1 0 011 1v7a2 2 0 01-2 2H6a2 2 0 01-2-2z" />
</svg>
`;

export default ToolCase;
